module.exports = __webpack_public_path__ + "static/img/ic_share@2x.7929748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/ic_share@2x.png
// module id = sV8Y
// module chunks = 10